/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountShortInfo} from '../models/AccountShortInfo';
import type {Error} from '../models/Error';
import type {GetManagedAccountIdsRequest} from '../models/GetManagedAccountIdsRequest';
import type {GetManagedAccountIdsResponse} from '../models/GetManagedAccountIdsResponse';

export interface GetManagedAccountIds$Request {
    accountManagerId: number;
    getManagedAccountIdsRequest: GetManagedAccountIdsRequest;
}

export interface GetManagedAccountIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getManagedAccountIdsRequest = createAction<PayloadData<void, GetManagedAccountIds$Request>>('GET_MANAGED_ACCOUNTS__GET_MANAGED_ACCOUNT_IDS__REQUEST');
export const getManagedAccountIdsSuccess = createAction<PayloadData<GetManagedAccountIdsResponse, GetManagedAccountIds$Request>>('GET_MANAGED_ACCOUNTS__GET_MANAGED_ACCOUNT_IDS__SUCCESS');
export const getManagedAccountIdsFailure = createAction<PayloadData<Error, GetManagedAccountIds$Request, true>>('GET_MANAGED_ACCOUNTS__GET_MANAGED_ACCOUNT_IDS__FAILURE');

export const getManagedAccountIdsActions = [
    getManagedAccountIdsRequest,
    getManagedAccountIdsSuccess,
    getManagedAccountIdsFailure
] as const;

/**
 * @param {number} meta.accountManagerId
 * @param {GetManagedAccountIdsRequest} meta.getManagedAccountIdsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getManagedAccountIds = (meta: GetManagedAccountIds$Request, config?: GetManagedAccountIds$Config) => {
    return {
        CALL_API: {
            types: getManagedAccountIdsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/account-managers/${meta.accountManagerId}/managed-accounts`,
            TRANSPORT_REQUEST_BODY: meta.getManagedAccountIdsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetManagedAccounts$Request {
    accountManagerId: number;
}

export interface GetManagedAccounts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getManagedAccountsRequest = createAction<PayloadData<void, GetManagedAccounts$Request>>('GET_MANAGED_ACCOUNTS__GET_MANAGED_ACCOUNTS__REQUEST');
export const getManagedAccountsSuccess = createAction<PayloadData<Array<AccountShortInfo>, GetManagedAccounts$Request>>('GET_MANAGED_ACCOUNTS__GET_MANAGED_ACCOUNTS__SUCCESS');
export const getManagedAccountsFailure = createAction<PayloadData<Error, GetManagedAccounts$Request, true>>('GET_MANAGED_ACCOUNTS__GET_MANAGED_ACCOUNTS__FAILURE');

export const getManagedAccountsActions = [
    getManagedAccountsRequest,
    getManagedAccountsSuccess,
    getManagedAccountsFailure
] as const;

/**
 * @param {number} meta.accountManagerId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getManagedAccounts = (meta: GetManagedAccounts$Request, config?: GetManagedAccounts$Config) => {
    return {
        CALL_API: {
            types: getManagedAccountsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/account-managers/${meta.accountManagerId}/accounts`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

